import styles from './SocialBarApp.less';
import SocialIcon from '@wix/restaurants-components-css-modules/dist/svg/SocialIcon/SvgSocialIcon';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SocialPlatformConverter from '@wix/wixrest-utils/dist/SocialPlatformConverter';

export default React.createClass({
    propTypes: {
        externalIds: PropTypes.object.isRequired,
        socialBarState: PropTypes.object.isRequired,
        i18n: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired,
        locale: PropTypes.string
    },

    render() {
        let { width, platformList, size, margin, withWrap, alignment } = this.props.socialBarState;
        let buttons = this._getButtons(platformList);
        let buttonElems = this._generateButtonElements(buttons, size, margin);
        let className = `${styles.wrapper} ${withWrap ? styles.withWrap : ''} ${styles[alignment]} ${buttons.length === 0 && (!_.isEmpty(platformList) && this._isOnEditor()) ? styles.emptyState : ''}`;
        let xAmount = this._getRealRowAmount(width, buttons.length, size, margin);
        let yAmount = Math.ceil(buttons.length / xAmount);
        let wrapperWidth = (xAmount * size) + (xAmount - 1) * margin;
        let wrapperHeight = (yAmount * size) + (yAmount - 1) * margin;

        return (
            <div className={className}>
                <div className={styles.innerWrapper} style={{width: wrapperWidth, height: wrapperHeight}}>
                    {buttonElems}
                </div>
            </div>
        );
    },

    _getRealRowAmount(width, length, size, margin) {
        let amount = length || 1;
        let innerWidth = (amount * size) + ((amount - 1) * margin);

        while (innerWidth > width && amount > 1) {
            amount--;
            innerWidth = (amount * size) + ((amount - 1) * margin);
        }

        return amount;
    },

    _generateButtonElements(buttons, size, margin) {
        let { socialBarState, i18n } = this.props;
        let { width, theme } = socialBarState;
        let counter = 0;
        let halfMargin = margin / 2;
        let start = i18n.i18n.isRtlDir() ? 'Left' : 'Right';
        let end = i18n.i18n.isRtlDir() ? 'Right' : 'Left';

        return _.map(buttons, (button, index) => {
            let link = button.link;
            let hasLink = !!link;
            let target = hasLink ? '_blank' : '_self';
            let style = {};

            if (counter > 0 && counter <= width) {
                style[`margin${end}`] = halfMargin;
            }

            counter += size + margin;

            if (counter + size <= width && index < buttons.length - 1) {
                style[`margin${start}`] = halfMargin;
            } else {
                counter = 0;
            }

            return <a target={target} key={index} href={link} style={style} onClick={() => this._onLinkClick(button.id)} title={i18n.I18N_EXTERNAL(`openrest_externalservices_com.${button.id}`)}>
                <SocialIcon type={button.id} dimension={size} theme={theme} hoverState={hasLink}/>
            </a>;
        });
    },

    _onLinkClick(id) {
        this.props.onClick(id);
        return true;
    },

    _isOnEditor(newProps) {
        let props = newProps || this.props;
        let { socialBarState } = props;
        return socialBarState.viewMode === 'editor';
    },

    _isOnPreview(newProps) {
        let props = newProps || this.props;
        let { socialBarState } = props;
        return socialBarState.viewMode === 'preview';
    },

    _isOnEditorOrPreview(newProps) {
        return this._isOnEditor(newProps) || this._isOnPreview(newProps);
    },

    _getButtons(platformList) {
        let { externalIds } = this.props;
        let buttons = [];
        externalIds = externalIds || {};

        for (let i = 0; i < platformList.length; i++) {
            let id = platformList[i];
            let link = this._parseLink(id, externalIds[`com.${id}`]);
            buttons.push({link, id});
        }

        return buttons;
    },

    _parseLink(linkType, id) {
        let link = null;

        if (linkType) {
            if (id && !this._isOnEditor()) {
                link = this._getRealLinks(linkType, id);
            } else if (this._isOnPreview()) {
                link = this._getPreviewLink(linkType);
            }
        }

        return link;
    },

    _getRealLinks(linkType, id) {
        let { externalIds } = this.props;
        let linkByUsername = false;

        switch (linkType) {
            case 'twitter':
                let username = externalIds['com.twitter.username'];
                id = username || id;
                linkByUsername = (username === id);
                break;
        }

        return SocialPlatformConverter.idToUrl(linkType, id, this.props.locale, linkByUsername);
    },

    _getPreviewLink(linkType) {
        let link = null;

        switch (linkType) {
            case 'facebook':
                link = 'https://www.facebook.com/wix';
                break;
            case 'foursquare':
                link = 'https://www.foursquare.com';
                break;
            case 'yelp':
                link = 'https://www.yelp.com/biz/wix-lounge-san-francisco';
                break;
            case 'tripadvisor':
                link = 'https://www.tripadvisor.com';
                break;
            case 'twitter':
                link = 'https://www.twitter.com/wix';
                break;
            case 'instagram':
                link = 'https://www.instagram.com/wix';
                break;
        }

        return link;
    }
});



// WEBPACK FOOTER //
// ./components/SocialBarApp/SocialBarApp.js